import { render, staticRenderFns } from "./orgSelect.vue?vue&type=template&id=4c037749&"
import script from "./orgSelect.vue?vue&type=script&lang=js&"
export * from "./orgSelect.vue?vue&type=script&lang=js&"
import style0 from "./orgSelect.vue?vue&type=style&index=0&id=4c037749&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports